import { LoginWindowType } from '../helpers/analytics';
import { LoginFlow } from '../types/flows';

export const loginWindowTypeMap = {
  phone: LoginWindowType.phone,
  personalLink: LoginWindowType.personalLink,
  sberIdOnly: LoginWindowType.sberIdOnly
};

export const loginFlowMap = {
  phone: LoginFlow.phone,
  personalLink: LoginFlow.sberPersonal,
  sberIdOnly: LoginFlow.sberid
};
